class InstaStories extends HTMLElement {
    constructor() {
        super(),
        this.openButtons = this.querySelectorAll(".insta-story-open-btn"),
        this.openButtonsOverflowContainer = this.querySelector(".insta-stories__open-buttons-container"),
        this.openButtonsContainer = this.querySelector(".insta-stories__open-buttons"),
        this.openBtnsPrev = this.querySelector(".insta-stories__open-btns-prev"),
        this.openBtnsNext = this.querySelector(".insta-stories__open-btns-next"),
        this.closeButtons = this.querySelectorAll(".insta-stories__close-button"),
        this.modal = this.querySelector(".insta-stories__modal"),
        this.modalOpen = !1,
        this.slider = this.querySelector(".insta-stories__slider"),
        this.stories = this.querySelectorAll(".insta-story"),
        this.prevBtns = this.querySelectorAll(".insta-story__prev"),
        this.nextBtns = this.querySelectorAll(".insta-story__next"),
        this.slideBtns = this.querySelectorAll(".insta-story__slide-btn"),
        this.activeIndex = 0,
        this.activeStory = this.stories[this.activeIndex],
        this.lastIndex = parseInt(this.dataset.lastIndex),
        this.pauseResumeBtns = this.querySelectorAll(".insta-story__pause-resume-btn"),
        this.isPaused = !1,
        this.volumeBtns = this.querySelectorAll(".insta-story__volume-btn"),
        this.isMuted = !0,
        this.initStories(),
        this.initButtonsSlider(),
        this.openButtons.forEach(t=>{
            t.addEventListener("click", this.openModal.bind(this))
        }
        ),
        this.closeButtons.forEach(t=>{
            t.addEventListener("click", this.closeModal.bind(this))
        }
        ),
        this.prevBtns.forEach(t=>{
            t.addEventListener("click", this.storyPrevBtnClick.bind(this))
        }
        ),
        this.nextBtns.forEach(t=>{
            t.addEventListener("click", this.storyNextBtnClick.bind(this))
        }
        ),
        this.slideBtns.forEach(t=>{
            t.addEventListener("click", this.slideBtnClick.bind(this))
        }
        ),
        this.pauseResumeBtns.forEach(t=>{
            t.addEventListener("click", this.togglePauseResume.bind(this))
        }
        ),
        this.volumeBtns.forEach(t=>{
            t.addEventListener("click", this.toggleIsMuted.bind(this))
        }
        ),
        this.slider.addEventListener("touchstart", this.touchStartHandler.bind(this)),
        this.slider.addEventListener("touchend", this.touchEndHandler.bind(this)),
        document.addEventListener("keydown", t=>{
            if (this.modalOpen)
                switch (t.key) {
                case "Escape":
                    this.closeModal();
                    break;
                case "ArrowLeft":
                    this.storyPrevBtnClick();
                    break;
                case "ArrowRight":
                    this.storyNextBtnClick()
                }
        }
        ),
        Shopify.designMode && (document.addEventListener("shopify:section:load", ()=>{
            this.initStories(),
            this.initButtonsSlider()
        }
        ),
        document.addEventListener("shopify:section:reorder", ()=>{
            this.initStories(),
            this.initButtonsSlider()
        }
        ))
    }
    autoplay() {
        let t = this.activeStory
          , e = parseInt(t.dataset.activeMediaIndex)
          , i = t.querySelectorAll(".insta-story__media")[e]
          , s = 1e3 * parseInt(i.getAttribute("data-duration"));
        this.updateProgressBars(e),
        this.autoplayStartTime = Date.now(),
        this.autoplayTimeout = setTimeout(()=>{
            this.storyNextBtnClick()
        }
        , s)
    }
    storyPrevBtnClick() {
        let t = this.activeStory;
        "0" === t.dataset.activeMediaIndex ? this.changeActiveStory(this.activeIndex - 1) : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) - 1)
    }
    storyNextBtnClick() {
        let t = this.activeStory;
        t.dataset.activeMediaIndex === t.dataset.lastMediaIndex ? this.changeActiveStory(this.activeIndex + 1) : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) + 1)
    }
    slideBtnClick(t) {
        let e = parseInt(t.currentTarget.dataset.index);
        this.changeActiveStory(e)
    }
    changeActiveStory(t) {
        if (clearTimeout(this.autoplayTimeout),
        t > this.lastIndex || t < 0)
            return;
        let e = this.stories[this.activeIndex]
          , i = parseInt(e.dataset.activeMediaIndex);
        if ("true" === e.dataset.played || i > 0) {
            let s = e.querySelectorAll(".insta-story__progress-item")[i];
            s && (s.classList.remove("insta-story__progress-item--active"),
            t > this.activeIndex && s.classList.add("insta-story__progress-item--completed"))
        }
        let n = e.querySelectorAll(".insta-story__media")[i];
        if (n && "video" === n.getAttribute("data-type")) {
            let o = n.querySelector("video");
            o && (o.pause(),
            this.isPaused || (o.currentTime = 0))
        }
        this.activeIndex = t,
        this.activeStory = this.stories[this.activeIndex],
        this.stories.forEach(t=>{
            t.classList.remove("insta-story--active")
        }
        ),
        this.activeStory.classList.add("insta-story--active"),
        this.activeStory.dataset.played = "true",
        this.slider.style.transform = `translateX(calc(var(--story-width) * ${-1 * this.activeIndex}))`;
        let r = parseInt(this.activeStory.dataset.activeMediaIndex, 10);
        this.changeActiveMedia(r),
        this.updateProgressBars(r)
    }
    changeActiveMedia(t) {
        if (clearTimeout(this.autoplayTimeout),
        t < 0)
            return;
        let e = this.activeStory
          , i = parseInt(e.dataset.lastMediaIndex);
        if (t > i)
            return;
        e.dataset.activeMediaIndex = t;
        let s = e.querySelectorAll(".insta-story__media");
        for (let n = 0; n < s.length; n++)
            if (n === t) {
                if (s[n].style.display = "block",
                "video" === s[n].getAttribute("data-type")) {
                    let o = s[n].querySelector("video");
                    o && !this.isPaused && o.play()
                }
                e.querySelector(".insta-story__time-posted").innerHTML = s[n].dataset.timePosted
            } else if (s[n].style.display = "",
            "video" === s[n].getAttribute("data-type")) {
                let r = s[n].querySelector("video");
                r && (r.pause(),
                this.isPaused || (r.currentTime = 0))
            }
        this.updateProgressBars(t),
        this.isPaused || this.autoplay();
        let a = e.querySelectorAll(".insta-story__prev")
          , l = e.querySelectorAll(".insta-story__next");
        a.forEach(e=>{
            0 === this.activeIndex && 0 === t ? e.setAttribute("disabled", "") : e.removeAttribute("disabled")
        }
        ),
        l.forEach(e=>{
            this.activeIndex === this.lastIndex && t === i ? e.setAttribute("disabled", "") : e.removeAttribute("disabled")
        }
        )
    }
    updateProgressBars(t) {
        let e = this.activeStory
          , i = e.querySelectorAll(".insta-story__progress-item");
        i.forEach((e,i)=>{
            e.classList.remove("insta-story__progress-item--completed", "insta-story__progress-item--active"),
            i < t ? e.classList.add("insta-story__progress-item--completed") : i === t && e.classList.add("insta-story__progress-item--active")
        }
        )
    }
    openModal(t) {
        window.scrollBy(0, -1),
        this.modal.dataset.open = "true",
        this.modalOpen = !0,
        document.body.classList.add("overflow-hidden"),
        this.changeActiveStory(parseInt(t.currentTarget.dataset.index))
    }
    closeModal(t) {
        this.querySelectorAll("video").forEach(t=>{
            t.pause()
        }
        ),
        this.modal.dataset.open = "false",
        this.modalOpen = !1,
        document.body.classList.remove("overflow-hidden"),
        clearTimeout(this.autoplayTimeout)
    }
    initButtonsSlider() {
        if (this.openButtonsOverflowContainer.clientWidth > this.openButtonsContainer.clientWidth)
            return;
        let t = ()=>"ontouchstart"in window || navigator.maxTouchPoints, e, i = 0, s = 0, n = t=>{
            this.openButtonsContainer.style.transform = `translateX(${t}px)`,
            i = t
        }
        ;
        this.openButtonsOverflowContainer.addEventListener("touchstart", t=>{
            this.isDragging = !0,
            e = t.touches[0].clientX - s
        }
        ),
        this.openButtonsOverflowContainer.addEventListener("touchmove", t=>{
            if (!this.isDragging)
                return;
            let i = t.touches[0].clientX
              , s = i - e;
            s < 0 && Math.abs(s) <= this.openButtonsContainer.offsetWidth - this.openButtonsOverflowContainer.offsetWidth && n(s)
        }
        ),
        this.openButtonsOverflowContainer.addEventListener("touchend", ()=>{
            this.isDragging = !1,
            s = i
        }
        );
        let o = parseFloat(getComputedStyle(this.openButtons[0]).width)
          , r = parseFloat(getComputedStyle(this.openButtonsContainer).columnGap)
          , a = ()=>{
            let t = Math.floor(this.openButtonsOverflowContainer.clientWidth / (o + r));
            return (t - 1) * (o + r)
        }
          , l = ()=>{
            this.openBtnsPrev.style.display = this.openButtonsOverflowContainer.scrollLeft <= 0 ? "none" : "grid",
            this.openBtnsNext.style.display = this.openButtonsOverflowContainer.scrollLeft > this.openButtonsOverflowContainer.scrollWidth - this.openButtonsContainer.clientWidth ? "none" : "grid"
        }
        ;
        this.openBtnsPrev.addEventListener("click", ()=>{
            this.openButtonsOverflowContainer.scrollBy({
                left: -a(),
                behavior: "smooth"
            }),
            setTimeout(l, 300)
        }
        ),
        this.openBtnsNext.addEventListener("click", ()=>{
            this.openButtonsOverflowContainer.scrollBy({
                left: a(),
                behavior: "smooth"
            }),
            setTimeout(l, 300)
        }
        ),
        l(),
        t() && (this.openBtnsPrev.style.display = "none",
        this.openBtnsNext.style.display = "none"),
        window.addEventListener("resize", debounce(()=>{
            this.openButtonsOverflowContainer.clientWidth <= this.openButtonsContainer.clientWidth ? t() ? (this.openBtnsPrev.style.display = "none",
            this.openBtnsNext.style.display = "none") : l() : (this.openBtnsPrev.style.display = "none",
            this.openBtnsNext.style.display = "none")
        }
        , 250))
    }
    initStories() {
        this.stories.forEach(t=>{
            let e = t.querySelectorAll(".insta-story__media");
            t.dataset.lastMediaIndex = e.length - 1,
            t.dataset.played = "false";
            let i = t.querySelector(".insta-story__progress");
            for (let s = 0; s < e.length; s++) {
                let n = e[s].getAttribute("data-duration")
                  , o = document.createElement("span");
                o.className = "insta-story__progress-item",
                o.style.setProperty("--duration", `${n}s`);
                let r = document.createElement("span");
                r.className = "insta-story__progress-bar",
                o.appendChild(r),
                i.appendChild(o)
            }
            let a = parseInt(t.dataset.activeMediaIndex);
            e[a] && (e[a].style.display = "block")
        }
        )
    }
    togglePauseResume(t) {
        let e = "true" === t.currentTarget.getAttribute("data-paused");
        e ? this.resumeStory() : this.pauseStory(),
        this.pauseResumeBtns.forEach(t=>{
            t.setAttribute("data-paused", e ? "false" : "true")
        }
        )
    }
    pauseStory() {
        this.isPaused = !0;
        let t = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)]
          , e = 1e3 * parseInt(t.getAttribute("data-duration"));
        if (this.remainingTime = e - (Date.now() - this.autoplayStartTime),
        clearTimeout(this.autoplayTimeout),
        "video" === t.getAttribute("data-type")) {
            let i = t.querySelector("video");
            i && i.pause()
        }
        let s = this.querySelectorAll(".insta-story__progress-bar");
        s.forEach(t=>{
            t.style.animationPlayState = "paused"
        }
        )
    }
    resumeStory() {
        this.isPaused = !1;
        let t = this.querySelectorAll(".insta-story__progress-bar");
        t.forEach(t=>{
            t.style.animationPlayState = "running"
        }
        );
        let e = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)];
        if ("video" === e.getAttribute("data-type")) {
            let i = e.querySelector("video");
            i && i.play()
        }
        this.autoplayStartTime = Date.now(),
        this.autoplayTimeout = setTimeout(()=>{
            this.storyNextBtnClick()
        }
        , this.remainingTime)
    }
    toggleIsMuted(t) {
        t.currentTarget,
        this.isMuted = !this.isMuted;
        let e = this.querySelectorAll("video");
        e.forEach(t=>{
            t.muted = this.isMuted
        }
        ),
        this.volumeBtns.forEach(t=>{
            this.isMuted ? t.setAttribute("data-muted", "true") : t.setAttribute("data-muted", "false")
        }
        )
    }
    touchStartHandler(t) {
        this.touchStartX = t.touches[0].clientX
    }
    touchEndHandler(t) {
        let e = t.changedTouches[0].clientX
          , i = e - this.touchStartX;
        !(50 > Math.abs(i)) && (i < 0 ? this.activeIndex < this.lastIndex && this.changeActiveStory(this.activeIndex + 1) : this.activeIndex > 0 && this.changeActiveStory(this.activeIndex - 1))
    }
}
customElements.define("insta-stories", InstaStories);